module.exports = __webpack_public_path__ + "img/career-2.009d285f.jpg";